import { render, staticRenderFns } from "./imgVideo.vue?vue&type=template&id=65b478cf&scoped=true"
import script from "./imgVideo.vue?vue&type=script&lang=js"
export * from "./imgVideo.vue?vue&type=script&lang=js"
import style0 from "./imgVideo.vue?vue&type=style&index=0&id=65b478cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b478cf",
  null
  
)

/* custom blocks */
import block0 from "./imgVideo.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports